module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('navbar', {
    staticStyle: {
      "width": "100%",
      "height": "72px"
    },
    style: (_vm.headerStyle),
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "home-search-header-mid"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "title-img"
  }, [_c('img', {
    staticStyle: {
      "width": "50px",
      "height": "46px",
      "padding-top": "10px"
    },
    attrs: {
      "src": "static/img/header/head_logo.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "title-text"
  }, [_c('span', [_vm._v("企业大数据平台")])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "nav-list"
  }, [_c('span', {
    staticClass: "right_nav_first"
  }, [_vm._v("咨询")]), _vm._v(" "), _c('span', {
    staticClass: "suxian"
  }), _vm._v(" "), _c('span', {
    staticClass: "right_nav"
  }, [_vm._v("产品与服务")]), _vm._v(" "), _c('span', {
    staticClass: "suxian"
  }), _vm._v(" "), _c('span', {
    staticClass: "right_nav"
  }, [_vm._v("招商加盟")]), _vm._v(" "), _c('span', {
    staticClass: "suxian"
  }), _vm._v(" "), _c('span', {
    staticClass: "right_nav"
  }, [_vm._v("登录")]), _vm._v(" "), _c('span', {
    staticClass: "suxian"
  }), _vm._v(" "), _c('span', {
    staticClass: "right_nav"
  }, [_vm._v("企业注册")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cafbf5d2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/Header.vue
// module id = 1097
// module chunks = 284